import { Injectable } from '@angular/core';
import { UnRx } from '@pebula/utils';
import { PendoServiceModel } from './models/pendo-service.model';
import { PendoUs } from './models/pendo.model';

@Injectable({
  providedIn: 'root',
})
@UnRx()
export class PendoUsService extends PendoServiceModel {
  constructor() {
    super();
  }

  /**  This function creates visitors and accounts in Pendo */
  initUser({ userId, legalEntityId }: PendoUs.PendoUserData) {
    const visitor: PendoUs.Visitor = {
      id: userId,
    };

    const account: PendoUs.Account = {
      id: legalEntityId,
    };

    this.initialize(visitor, account);
  }
}
